// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3kE4J","info":"UpdateTermsInfo_info__3zc3U"};